import React from 'react';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 mt-12 border-t border-gray-200">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <img
            src="/Logo.png"
            alt="Coffee On Cue"
            className="h-10 w-auto"
          />

          {/* Year */}
          <p className="text-sm text-gray-500">
            © {currentYear} Coffee On Cue. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
